























































































import { Catalogo, CatalogosService } from "@/services/catalogos.service";
import { ProdutoMaisVendido, RelatorioService } from "@/services/relatorio.service";
import DatePickerCalendar from "@/shared/components/date-picker-calendar.vue";
import Warning from "@/shared/components/warning.vue";
import { dateTime } from "@/shared/filters";
import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";
import * as XLSX from "xlsx";

@Component({
  components: {
    DatePickerCalendar,
    Warning,
  },
  filters: { dateTime },
})
export default class RelatorioProdutosMaisVendidos extends Vue {
  loading = false;
  periodoInicial = "";
  periodoFinal = "";
  idsCatalogo: string[] = [];
  catalogos: Catalogo[] = [];

  get todosSelecionados(): boolean {
    return this.catalogos.length > 0 && this.idsCatalogo.length === this.catalogos.length;
  }

  get iconeDeTodos(): string {
    if (this.todosSelecionados) return "mdi-checkbox-marked";
    if (this.idsCatalogo.length > 0) return "mdi-minus-box";
    return "mdi-checkbox-blank-outline";
  }

  alternarTodos() {
    this.idsCatalogo = this.todosSelecionados
      ? []
      : this.catalogos.map((catalogo) => catalogo.idCatalogo);
  }

  // As datas sao definidas em mounted, e nao em created, porque o date-picker-calendar
  // aplica o dataInitialize por um @Watch sem immediate: valor que ja chega pronto no
  // primeiro render nao dispara o watcher e o campo fica vazio.
  mounted() {
    const mesAnterior = dayjs().subtract(1, "month");
    this.periodoInicial = mesAnterior.startOf("month").format("DD/MM/YYYY");
    this.periodoFinal = mesAnterior.endOf("month").format("DD/MM/YYYY");

    this.buscarCatalogos();
  }

  buscarCatalogos() {
    this.loading = true;
    CatalogosService.listarCatalogosGlobaisPaginado({
      term: "",
      somenteAtivos: true,
      offset: 0,
      limit: 100,
      order: "",
    })
      .then((result) => {
        this.catalogos = result.lista;
        this.idsCatalogo = result.lista.map((catalogo) => catalogo.idCatalogo);
      })
      .finally(() => (this.loading = false));
  }

  async gerarRelatorio() {
    const modalWarning = this.$refs.warning as Warning;

    if (!this.periodoInicial || !this.periodoFinal) {
      await modalWarning.open(
        "Uma das datas não foi selecionada",
        "Favor preencher ambas as datas antes de continuar."
      );
      return;
    }

    if (this.idsCatalogo.length === 0) {
      await modalWarning.open(
        "Nenhum catálogo foi selecionado",
        "Favor selecionar ao menos um catálogo antes de continuar."
      );
      return;
    }

    this.loading = true;

    const relatorio = await RelatorioService.GerarRelatorioProdutosMaisVendidos(
      `${this.periodoInicial} - ${this.periodoFinal}`,
      this.idsCatalogo
    ).finally(() => (this.loading = false));

    if (!relatorio || relatorio.length === 0) {
      await modalWarning.open(
        "Registros não foram encontrados",
        "Não foi possível encontrar vendas de produtos no período informado."
      );
      return;
    }

    this.exportar(relatorio);
  }

  exportar(relatorio: ProdutoMaisVendido[]) {
    const worksheet = XLSX.utils.json_to_sheet(relatorio);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Relatorio");

    XLSX.utils.sheet_add_aoa(
      worksheet,
      [["Catálogo", "Produto", "Quantidade Vendida", "Imagem"]],
      { origin: "A1" }
    );

    const larguraDoCatalogo = relatorio.reduce(
      (largura, linha) => Math.max(largura, (linha.NomeCatalogo || "").length),
      20
    );
    const larguraDoProduto = relatorio.reduce(
      (largura, linha) => Math.max(largura, (linha.NomeProduto || "").length),
      30
    );

    worksheet["!cols"] = [
      { wch: larguraDoCatalogo },
      { wch: larguraDoProduto },
      { wch: 20 },
      { wch: 60 },
    ];

    XLSX.writeFile(workbook, "ProdutosMaisVendidos.xlsx");
  }
}
